module.exports = __webpack_public_path__ + "img/Calming Presence.bca9ca3e.svg";